"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    blNo: {
      type: String,
      default: ''
    },
    pol: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentRow: '',
      loading: null,
      isAcceptedList: [],
      isDgList: [{
        codeValue: 1,
        displayValueCn: '普通',
        displayValue: 'Dry'
      }, {
        codeValue: 2,
        displayValueCn: '冻柜',
        displayValue: 'Reefer'
      }, {
        codeValue: 3,
        displayValueCn: '特种箱',
        displayValue: 'Special Container'
      }, {
        codeValue: 4,
        displayValueCn: '危险品',
        displayValue: 'Hazardous'
      }],
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: 1,
        name: 'Reshipment'
      }],
      mktFrtContainerVos: [],
      form: {
        vesselCode: '',
        serviceLineCode: '',
        vesselName: '',
        voyageNo: '',
        voyageLeg: '',
        currentPage: 1,
        pageSize: 10,
        isDg: ''
      },
      rules: {
        demuFreeDays: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur',
          validator: this.customValidator
        }],
        detenFreeDays: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur',
          validator: this.customValidator
        }]
      },
      total: 0,
      tableData: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['DOC_APPROVAL_STATUS'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.isAcceptedList = res.DOC_APPROVAL_STATUS ? res.DOC_APPROVAL_STATUS : [];
    });
  },
  mounted: function mounted() {},
  methods: {
    validateNull: _validate.validateNull,
    handleDelete: function handleDelete() {
      var index = this.mktFrtContainerVos.indexOf(this.currentRow);
      this.mktFrtContainerVos.splice(index, 1);
      this.form.mktFrtContainerVos[index].rowStatus = 8;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    customValidator: function customValidator(rule, value, callback) {
      if (this.form.demuFreeDays || this.form.detenFreeDays) {
        callback();
      } else {
        callback(new Error(this.$t('home.placehold')));
      }
    },
    opened: function opened() {
      this.handleSearch();
      //console.log('opened')
    },
    handleReset: function handleReset() {
      this.form = {
        vesselCode: '',
        serviceLineCode: '',
        vesselNameCn: '',
        voyageNo: '',
        voyageLeg: '',
        currentPage: 1,
        pageSize: 100
      };
    },
    handleSelectionChange: function handleSelectionChange(selections, row) {
      if (selections.length > 1) {
        var del_row = selections.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
        this.multipleSelection = selections;
      } else {
        this.multipleSelection = selections;
      }
    },
    handleSubimt: function handleSubimt() {
      console.log(this.multipleSelection[0]);
      this.$emit('selectionChange', this.multipleSelection[0]);
    },
    handleClear: function handleClear() {
      this.form = {
        vesselCode: '',
        serviceLineCode: '',
        vesselNameCn: '',
        voyageNo: '',
        voyageLeg: '',
        currentPage: 1,
        pageSize: 100
      };
    },
    closed: function closed() {
      this.handleClear();
    },
    handleSubimtDraft: function handleSubimtDraft() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.loading = (0, _utils.load)();
          (0, _booking.doReturnDraft)(_this2.form).then(function (res) {
            if (res.success) {
              _this2.$message.success(_this2.$t("home.ftapplyMessageCopy"));
              _this2.$parent.handleSearch();
              _this2.$parent.ftDialogVisible = false;
            } else {
              _this2.$message.warning(res.errorMessages[0]);
            }
          }).finally(function () {
            _this2.loading.close();
          });
        } else {
          return false;
        }
      });
    },
    handleSubimtDoApplyFt: function handleSubimtDoApplyFt() {
      var _this3 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this3.loading = (0, _utils.load)();
          (0, _booking.doApplyFt)(_this3.form).then(function (res) {
            if (res.success) {
              _this3.$message.success(_this3.$t("home.ftapplyMessage"));
              _this3.$parent.handleSearch();
              _this3.$parent.ftDialogVisible = false;
            } else {
              _this3.$message.warning(res.errorMessages[0]);
            }
          }).finally(function () {
            _this3.loading.close();
          });
        } else {
          return false;
        }
      });
    },
    handleButtonClose: function handleButtonClose() {
      this.$parent.ftDialogVisible = false;
      console.log(this.isAcceptedList, 'isAcceptedList88888888888888');
    },
    handleSearch: function handleSearch() {
      var _this4 = this;
      var data = this.blNo;
      // const data  ='SITTAGVT722199'
      (0, _booking.getFreetimelnfo)(data).then(function (res) {
        _this4.form = res.data;
        _this4.mktFrtContainerVos = _this4.form.mktFrtContainerVos.slice(0);
        _this4.form.vesselAndVoyage = _this4.form.vesselCode + '/' + _this4.form.voyageNo + '/' + _this4.form.voyageLeg;
      });
    }
  }
};